import m from "mithril";

type Variant =
  | "title"
  | "subtitle"
  | "label"
  | "text"
  | "error"
  | "hint"
  | "hintdescription"
  | "header"
  | "sectiontitle"
  | "cardheader"
  | "body"
  | "value"
  | "code"
  | "original";

const variantStyles: Record<Variant, { selector: string; classname: string }> = {
  title: { selector: "h1", classname: "text-2xl font-semi-bold" },
  subtitle: { selector: "h2", classname: "text-xl font-semi-bold" },
  header: { selector: "h3", classname: "text-lg font-semi-bold" },
  sectiontitle: { selector: "div", classname: "text-base font-semi-bold text-slate-500" },
  cardheader: { selector: "div", classname: "text-base font-semi-bold text-slate-900" },
  label: { selector: "label", classname: "text-sm font-medium" },
  body: { selector: "p", classname: "text-sm leading-normal mb-2 text-slate-700 whitespace-pre-line" },
  error: { selector: "p", classname: "text-sm leading-normal mb-2 text-red-600 whitespace-pre-line" },
  hint: { selector: "div", classname: "text-xs leading-normal text-slate-700 whitespace-pre-line" },
  hintdescription: { selector: "div", classname: "text-xs leading-normal text-slate-500 whitespace-pre-line" },
  text: { selector: "div", classname: "text-sm whitespace-pre-line" },
  value: { selector: "div", classname: "text-sm whitespace-pre-line text-slate-500" },
  code: { selector: "div", classname: "text-xs whitespace-pre font-mono" },
  original: { selector: "div", classname: "" },
};

interface Attrs {
  variant?: Variant;
}

export const Text: m.Component<Attrs> = {
  view({ attrs: { variant = "text" }, children }) {
    const { selector, classname } = variantStyles[variant];

    return m(selector, { class: classname }, children);
  },
};
